import { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import * as queries from "../graphql/queries";
import getLinks from "../utils/getLinks";

const useAllComptetivePlayers5x5List = () => {
  const [allLeaguesUsersList, setGetLeaguesUserList] = useState([]);
  const [verifiedLeaguesUsersList, setVerifiedGetLeaguesUserList] = useState(
    []
  );
  const [notVerifiedLeaguesUsersList, setNonVerifiedGetLeaguesUserList] =
    useState([]);
  const [playerDetails, setPlayerDetails] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLeaguesUser = async () => {
      try {
        setLoading(true);
        const response = await API.graphql({
          query: queries.listComptetiveUser5X5s,
          authMode: GRAPHQL_AUTH_MODE.API_KEY,
        });
        const tryoutsVariables = {
          limit : 10,
          nextToken : null,
        };
        // Fetch tryouts data
        const tryoutsResponse = await API.graphql(
          graphqlOperation(queries.listTryout5X5s, tryoutsVariables),
          {
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          }
        );

        if (
          tryoutsResponse &&
          tryoutsResponse.data &&
          tryoutsResponse.data.listTryout5X5s
        ) {
          const tryouts = tryoutsResponse.data.listTryout5X5s.items || [];

          // Fetch competitive users data
          const comptetiveUsersResponse = await API.graphql(
            graphqlOperation(queries.listComptetiveUser5X5s),
            {
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            }
          );

          const comptetiveUsers =
            comptetiveUsersResponse?.data?.listComptetiveUser5X5s?.items || [];

          // Filter competitive users where transactionStatus is 'success'
          const invitedUsers = comptetiveUsers.filter(
            (user) => user.transactionStatus?.toLowerCase() === "success"
          );

          // Map through tryouts and keep only those whose userId matches an invited user
          const invitedTryouts = invitedUsers.filter((tryout) =>
            tryouts.some((user) => user.userId === tryout.userId)
          );
       
       
        // Sort the array alphabetically by participantName
        invitedTryouts.sort((a, b) =>
          a.participantName.localeCompare(b.participantName)
        );

        // Group same teams together
        const groupedByTeam = {};
        invitedTryouts.forEach((player) => {
          const teamName = player.teamName;
          if (!groupedByTeam[teamName]) {
            groupedByTeam[teamName] = [];
          }
          groupedByTeam[teamName].push(player);
        });

        // Sort teams array
        const sortedTeams = Object.keys(groupedByTeam).sort();

        // Map teams back to array in sorted order
        const sortedGroupedData = sortedTeams.map(
          (team) => groupedByTeam[team]
        );

        // Flatten into single array
        const flattenedSortedData = sortedGroupedData.flat();

        const promises = flattenedSortedData.map(async (player) => {
          // const imageLink = await getLink(player?.profile);
          // return { ...player, imageLink };
          const url = await getLinks(player?.profile);
          return { ...player, playerUrl: url };
        });

        const playersWithImages = await Promise.all(promises);

        const notVerifiedUsers = flattenedSortedData?.filter(
          (item) => item?.isVerified === null
        );
        const verifiedUsers = flattenedSortedData?.filter(
          (item) => item?.isVerified === true
        );

        setLoading(false);
        setGetLeaguesUserList(playersWithImages);
        setNonVerifiedGetLeaguesUserList(notVerifiedUsers);
        setVerifiedGetLeaguesUserList(verifiedUsers);
      }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching leagues:", error);
        throw error;
      }
    };

    fetchLeaguesUser();
  }, []);

  return {
    allLeaguesUsersList,
    verifiedLeaguesUsersList,
    notVerifiedLeaguesUsersList,
    loading,
  };
};

export default useAllComptetivePlayers5x5List;
